import Textarea from "../../../components/input/textarea";
import {setPlain, usePlain} from "../documents/editor/EditorContext";

export const TextPanel = ({errors}) => {
    const plain = usePlain();

    return (
        <>
            <div className={errors ? 'has-errors' : ''}>
                <Textarea
                    size="md"
                    isReady={true}
                    name="description"
                    value={plain}
                    placeholder="Type a short description..."
                    style={{border: 'none', resize: 'none', height: 'calc(100vh - 65px)', padding: 20}}
                    onBlur={ev => setPlain(ev.target.value)}
                />
            </div>
        </>
    )
}